import React, { useEffect, useState } from "react";
import "./PopUpHeart.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHeart } from '@fortawesome/free-solid-svg-icons';
import { removePOI, addPOI, getSnapShot, removeNewPoi } from "../../../../redux/actions/nbhd/nbhd";
import { RootState } from "../../../../redux/reducers/root";
import { useSelector, useDispatch } from 'react-redux';
import AmpInlineLoadingSpinner from "../../../common/AmpInlineLoadingSpinner/AmpInlineLoadingSpinner";
import Tooltip from "../../../common/ToolTip/ToolTip";
import { useTranslation } from "react-i18next";
import { setToastNotification } from "../../../../redux/actions/toastNotification/toastNotification";

interface PopUpHeartProps {
    // 0: -, 1:+, 2: do not show
    address: string;
    indicateNum: number | undefined;
    rollNum: string;
    parentRoll: string;
}

export default function PopUpHeart(props: PopUpHeartProps) {
    const currentProp = useSelector((state: RootState) => state.propertyListReducer.currentProperty);
    const userProfileId = window.localStorage.getItem("userProfileId") as string;

    const { t } = useTranslation(["nbhd"]);

    const dispatch = useDispatch();
    const ownerType = currentProp["currentOwnerType"];
    const [requestSent, setReqSent] = useState(false);

    const [indicateNumState, setIndNum] = useState<number>();

    let symbol = '';
    let toolTipText = '';

    useEffect(() => {
        // props changed meaning the request went through
        if (props.indicateNum !== indicateNumState && indicateNumState !== undefined) {
            setReqSent(false);
            // We just succesfully added a POI
            if(indicateNumState === 1 && props.indicateNum === 0){
                dispatch(setToastNotification(t('nbhd.popup-card.toast-add', { roll: props.address}), "success"));
                setIndNum(undefined);
            // We just succesfully removed a POI
            } else if (indicateNumState === 0 && (props.indicateNum === 1 || props.indicateNum === 2)) {
                dispatch(setToastNotification(t('nbhd.popup-card.toast-rem', { roll: props.address}), "success"));
                dispatch(getSnapShot(userProfileId, props.parentRoll, props.rollNum, ownerType));
                setIndNum(props.indicateNum);
            } else {
                setIndNum(props.indicateNum);
            }
            
        }
    }, [props, indicateNumState, dispatch, ownerType, t, userProfileId])


    if (props.indicateNum === 1) {
        symbol = '+';
        toolTipText = t("nbhd.POI.clicking-add");
    } else if(props.indicateNum === 0){
        symbol = '-';
        toolTipText = t("nbhd.POI.clicking-rem");
    } else if(props.indicateNum === 2 || props.indicateNum === 3) {
        return <></>;
    }  

    const addRemove = (userId: string, parent: string, roll: string, owner: string, indicate: number) => {
        if (indicate === 1) {
            dispatch(addPOI(userId, parent, roll, owner));
            setIndNum(1);
        } else if (indicate === 0) {
            setIndNum(0);
            dispatch(removePOI(userId, parent, roll, owner));
            dispatch(removeNewPoi(roll));
        }
        setReqSent(true);
    }

    return (
        <>
            <div id="poiButton" className={`col-md-12 no-padding ${requestSent ? "disabled" : ""}`}>
                <Tooltip
                    content={toolTipText} 
                    direction={"top"}
                    offsetBottom={60}
                >
                    <button id="addPoiBtn" className="balloon-favourite-button" onClick={() => addRemove(userProfileId, props.parentRoll, props.rollNum, ownerType, props.indicateNum, dispatch)}>
                        <div id="addPoiTooltip">
                            <span className="add-remove-poi-text">
                                <FontAwesomeIcon className="fa-heart-large" icon={faHeart} />
                                {symbol}
                            </span>
                        </div>
                    </button>
                </Tooltip>
                {requestSent && <AmpInlineLoadingSpinner />}
            </div>
            
        </>
    );
}


